import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <main className="policy-page privacy">
      <header className="policy-hero policy-hero--legal">
        <p className="policy-eyebrow">Legal</p>
        <h1>Privacy notice</h1>
        <p>
          A plain-language overview of how {siteConfig.brandName} handles
          personal information.
        </p>
        <span>Last updated 13 August 2026</span>
      </header>

      <div className="policy-layout">
        <nav className="policy-nav" aria-label="Legal pages">
          <p>Legal information</p>
          <Link className="is-active" to="/privacy" aria-current="page">
            Privacy notice <span aria-hidden="true">→</span>
          </Link>
          <Link to="/terms" onClick={toTop}>
            Terms of use <span aria-hidden="true">→</span>
          </Link>
          <Link to="/contact" onClick={toTop}>
            Contact us <span aria-hidden="true">→</span>
          </Link>
        </nav>

        <article className="policy-content policy-content--legal">
          <section className="policy-intro" aria-labelledby="privacy-overview">
            <p className="policy-eyebrow">Your information</p>
            <h2 id="privacy-overview">Designed with care and restraint.</h2>
            <p>
              We believe a store should explain what it collects, why it needs
              it, and the choices available to you. A production service would
              use personal information only to operate the store, support you,
              improve the experience, and meet legal obligations.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="privacy-collect">
            <div className="policy-section__heading">
              <span>01</span>
              <h2 id="privacy-collect">Information we may collect</h2>
            </div>
            <ul>
              <li>
                <strong>Details you provide:</strong> name, email,
                delivery and billing details, messages, and product preferences.
              </li>
              <li>
                <strong>Transaction details:</strong> items, order values,
                discounts, returns, and payment status. Full card details would
                be handled by an authorised payment provider, not this front end.
              </li>
              <li>
                <strong>Device and usage data:</strong> browser type, approximate
                region, pages visited, referral source, and interaction events.
              </li>
              <li>
              <strong>Local storefront data:</strong> this site saves cart
                selections in your browser so they remain available on return.
              </li>
            </ul>
          </section>

          <section className="policy-section" aria-labelledby="privacy-use">
            <div className="policy-section__heading">
              <span>02</span>
              <h2 id="privacy-use">How information may be used</h2>
            </div>
            <p>
              Information may be used to fulfil and deliver purchases, provide
              order updates, respond to enquiries, prevent misuse, manage
              returns, maintain the service, and understand which experiences
              are useful. Marketing messages would be sent only where permitted,
              and each message would include a way to opt out.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="privacy-share">
            <div className="policy-section__heading">
              <span>03</span>
              <h2 id="privacy-share">Service providers &amp; transfers</h2>
            </div>
            <p>
              A live store may share only the necessary information with trusted
              providers such as hosting, payments, delivery, customer support,
              fraud prevention, and analytics partners. Contracts and
              appropriate safeguards should govern that access. Information may
              also be disclosed where the law requires it or to protect people,
              rights, and the service.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="privacy-retention">
            <div className="policy-section__heading">
              <span>04</span>
              <h2 id="privacy-retention">Retention &amp; security</h2>
            </div>
            <p>
              Records should be retained only as long as needed for the stated
              purpose, legitimate business requirements, and applicable law.
              Reasonable organisational and technical measures can reduce risk,
              but no online system can promise absolute security.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="privacy-rights">
            <div className="policy-section__heading">
              <span>05</span>
              <h2 id="privacy-rights">Your choices &amp; rights</h2>
            </div>
            <p>
              Depending on your location, you may be able to access, correct,
              delete, restrict, or object to certain processing, request a copy
              of your information, or withdraw consent. You can also clear this
              site’s cart data through your browser storage controls.
            </p>
          </section>

          <section className="policy-section" aria-labelledby="privacy-updates">
            <div className="policy-section__heading">
              <span>06</span>
              <h2 id="privacy-updates">Children &amp; notice updates</h2>
            </div>
            <p>
              The store is intended for adults and is not designed to knowingly
              collect information from children. A material update to a live
              notice should be dated and communicated in an appropriate way.
            </p>
          </section>

          <section className="policy-help" aria-labelledby="privacy-help">
            <div>
              <p className="policy-eyebrow">Privacy questions</p>
              <h2 id="privacy-help">Ask us about your information.</h2>
            </div>
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email} <span aria-hidden="true">↗</span>
            </a>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Privacy;
